import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Article, ArticleCarouselActionMode, SolrResultEntityRef } from '../../../../core/model';
import { CatalogArticleRowComponent } from '../catalog-article-row/catalog-article-row.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tbody[py-catalog-similar-articles-row]',
  templateUrl: './catalog-similar-articles-row.component.html',
  styleUrls: ['./catalog-similar-articles-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CatalogSimilarArticlesRowComponent {
  readonly carouselActionModes: typeof ArticleCarouselActionMode = ArticleCarouselActionMode;

  @Input() articleResultRef: SolrResultEntityRef;
  @Input() articleRowComponent: CatalogArticleRowComponent;

  get article$(): Observable<Article> {
    return this.articleRowComponent.article$;
  }

  get isSimilarArticlesExpanded$(): Observable<boolean> {
    return this.articleRowComponent.isSimilarArticlesExpanded$;
  }

  get showArticleError$(): Observable<boolean> {
    return this.articleRowComponent.showArticleError$;
  }
}
